import React        from 'react'
import { Link }     from 'react-static'
import ScrollToTop  from 'react-scroll-up'
//
export default() =>(
    <ScrollToTop showUnder={2000} style={{right: '20px', bottom: '15%', zIndex: '2'}}>
        <div className="linktop">
            <span className="linktop__label">Top</span>
        </div>
    </ScrollToTop>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/LinkTop.js